var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 143 143",
    style: {
      enableBackground: "new 0 0 143 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{clip-path:url(#SVGID_00000072973478591293676930000006109423946732068481_)}.st1{clip-path:url(#SVGID_00000085945711194172621910000001585323035227408539_);fill:#fff}.st3{clip-path:url(#SVGID_00000173128595030576781660000002453218877793633676_)}.st4{clip-path:url(#SVGID_00000100352392476260436190000005047698917991419267_);fill:#4cc2f1}.st5{clip-path:url(#SVGID_00000040544823602545814310000012363138933544005248_)}.st6{clip-path:url(#SVGID_00000074403725109898317960000013297629394504410005_);fill:#31348b}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2 71.5c0-2.6 4.4-4.8 4.7-7.3.3-2.5-3.5-5.7-2.9-8.2.6-2.5 5.3-3.7 6.2-6.1.8-2.4-2.1-6.4-1-8.6 1.1-2.3 6-2.4 7.4-4.6 1.3-2.1-.7-6.7.9-8.6 1.6-2 6.4-1 8.2-2.8 1.8-1.8.8-6.6 2.8-8.2 2-1.6 6.5.4 8.6-.9 2.1-1.3 2.3-6.3 4.6-7.4 2.3-1.1 6.2 1.9 8.6 1 2.4-.8 3.6-5.6 6.1-6.2 2.4-.6 5.6 3.2 8.2 2.9C66.7 6.4 69 2 71.5 2c2.6 0 4.8 4.4 7.3 4.7 2.5.3 5.7-3.5 8.2-2.9 2.5.6 3.7 5.3 6.1 6.2 2.4.8 6.3-2.1 8.6-1s2.4 6 4.6 7.4c2.1 1.3 6.7-.7 8.6.9 2 1.6 1 6.4 2.8 8.2 1.8 1.8 6.6.8 8.2 2.8 1.6 2-.4 6.5.9 8.6 1.3 2.1 6.3 2.3 7.4 4.6 1.1 2.3-1.9 6.2-1 8.6.8 2.4 5.6 3.6 6.2 6.1.6 2.4-3.2 5.6-2.9 8.2.3 2.5 4.7 4.8 4.7 7.3s-4.4 4.8-4.7 7.3c-.3 2.5 3.5 5.7 2.9 8.2-.6 2.5-5.3 3.7-6.2 6.1-.8 2.4 2.1 6.3 1 8.6s-6 2.4-7.4 4.6c-1.3 2.1.7 6.7-.9 8.6-1.6 2-6.4 1-8.2 2.8-1.8 1.8-.8 6.6-2.8 8.2-2 1.6-6.5-.4-8.6.9-2.1 1.3-2.3 6.3-4.6 7.4-2.3 1.1-6.2-1.9-8.6-1-2.4.8-3.6 5.6-6.1 6.2-2.4.6-5.6-3.2-8.2-2.9-2.5.3-4.8 4.7-7.3 4.7-2.6 0-4.8-4.4-7.3-4.7-2.5-.3-5.7 3.5-8.2 2.9-2.5-.6-3.7-5.3-6.1-6.2-2.4-.8-6.3 2.1-8.6 1s-2.4-6-4.6-7.4c-2.1-1.3-6.7.7-8.6-.9-2-1.6-1-6.4-2.8-8.2-1.8-1.8-6.6-.8-8.2-2.8-1.6-2 .4-6.5-.9-8.6-1.3-2.1-6.3-2.3-7.4-4.6-1.1-2.3 1.9-6.2 1-8.6-.8-2.4-5.6-3.6-6.2-6.1-.6-2.4 3.2-5.6 2.9-8.2-.1-2.7-4.5-4.9-4.5-7.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126300700241773104410000018310592082585116317_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000126300700241773104410000018310592082585116317_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000093147766972873906390000003949859296454471855_",
    d: "M-206-364h390v997h-390z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165927916625694086950000010774806668720411579_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093147766972873906390000003949859296454471855_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000165927916625694086950000010774806668720411579_)",
      fill: "#fff"
    },
    d: "M1 1h141v141H1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 71.5c0-2.6 4.4-4.8 4.7-7.3.3-2.5-3.5-5.7-2.9-8.2.6-2.5 5.3-3.7 6.2-6.1.8-2.4-2.1-6.4-1-8.6 1.1-2.3 6-2.4 7.4-4.6 1.3-2.1-.7-6.7.9-8.6 1.6-2 6.4-1 8.2-2.8 1.8-1.8.8-6.6 2.8-8.2 2-1.6 6.5.4 8.6-.9 2.1-1.3 2.3-6.3 4.6-7.4 2.3-1.1 6.2 1.9 8.6 1 2.4-.8 3.6-5.6 6.1-6.2 2.4-.6 5.6 3.2 8.2 2.9C66.7 6.4 69 2 71.5 2c2.6 0 4.8 4.4 7.3 4.7 2.5.3 5.7-3.5 8.2-2.9 2.5.6 3.7 5.3 6.1 6.2 2.4.8 6.3-2.1 8.6-1s2.4 6 4.6 7.4c2.1 1.3 6.7-.7 8.6.9 2 1.6 1 6.4 2.8 8.2s6.6.8 8.2 2.8c1.6 2-.4 6.5.9 8.6 1.3 2.1 6.3 2.3 7.4 4.6 1.1 2.3-1.9 6.2-1 8.6.8 2.4 5.6 3.6 6.2 6.1.6 2.4-3.2 5.6-2.9 8.2.3 2.5 4.7 4.8 4.7 7.3s-4.4 4.8-4.7 7.3c-.3 2.5 3.5 5.7 2.9 8.2-.6 2.5-5.3 3.7-6.2 6.1-.8 2.4 2.1 6.3 1 8.6s-6 2.4-7.4 4.6c-1.3 2.1.7 6.7-.9 8.6-1.6 2-6.4 1-8.2 2.8-1.8 1.8-.8 6.6-2.8 8.2-2 1.6-6.5-.4-8.6.9-2.1 1.3-2.3 6.3-4.6 7.4-2.3 1.1-6.2-1.9-8.6-1-2.4.8-3.6 5.6-6.1 6.2-2.4.6-5.6-3.2-8.2-2.9-2.5.3-4.8 4.7-7.3 4.7-2.6 0-4.8-4.4-7.3-4.7-2.5-.3-5.7 3.5-8.2 2.9-2.5-.6-3.7-5.3-6.1-6.2-2.4-.8-6.3 2.1-8.6 1s-2.4-6-4.6-7.4c-2.1-1.3-6.7.7-8.6-.9-2-1.6-1-6.4-2.8-8.2-1.8-1.8-6.6-.8-8.2-2.8-1.6-2 .4-6.5-.9-8.6-1.3-2.1-6.3-2.3-7.4-4.6-1.1-2.3 1.9-6.2 1-8.6-.8-2.4-5.6-3.6-6.2-6.1-.6-2.4 3.2-5.6 2.9-8.2-.1-2.7-4.5-4.9-4.5-7.5",
    style: {
      fill: "none",
      stroke: "#31348b",
      strokeWidth: 4,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000109721811829382026760000014822334531668352164_",
    d: "M17 71c0-2 3.4-3.8 3.6-5.7.2-2-2.7-4.4-2.3-6.3.4-1.9 4.2-2.9 4.8-4.7.7-1.9-1.7-4.9-.8-6.7.9-1.8 4.7-1.9 5.7-3.5 1-1.7-.5-5.2.7-6.7s5-.8 6.4-2.2c1.4-1.4.6-5.2 2.2-6.4 1.5-1.2 5 .3 6.7-.7 1.7-1 1.8-4.9 3.5-5.7 1.8-.8 4.8 1.5 6.7.8 1.8-.6 2.8-4.4 4.7-4.8 1.9-.4 4.4 2.5 6.3 2.3 2-.3 3.8-3.7 5.8-3.7s3.8 3.4 5.7 3.6c2 .2 4.4-2.7 6.3-2.3 1.9.4 2.9 4.2 4.7 4.8 1.9.7 4.9-1.7 6.7-.8 1.8.9 1.9 4.7 3.5 5.7 1.7 1 5.2-.5 6.7.7s.8 5 2.2 6.4c1.4 1.4 5.2.6 6.4 2.2 1.2 1.5-.3 5 .7 6.7 1 1.7 4.9 1.8 5.7 3.5.8 1.8-1.5 4.8-.8 6.7.6 1.8 4.4 2.8 4.8 4.7.4 1.9-2.5 4.4-2.3 6.3.2 1.9 3.6 3.7 3.6 5.7s-3.4 3.8-3.6 5.7c-.2 2 2.7 4.4 2.3 6.3-.4 1.9-4.2 2.9-4.8 4.7-.7 1.9 1.7 4.9.8 6.7-.9 1.8-4.7 1.9-5.7 3.5-1 1.7.5 5.2-.7 6.7s-5 .8-6.4 2.2c-1.4 1.4-.6 5.2-2.2 6.4-1.5 1.2-5-.3-6.7.7-1.7 1-1.8 4.9-3.5 5.7-1.8.8-4.8-1.5-6.7-.8-1.8.6-2.8 4.4-4.7 4.8-1.9.4-4.4-2.5-6.3-2.3-1.9.2-3.7 3.6-5.7 3.6s-3.8-3.4-5.7-3.6c-2-.2-4.4 2.7-6.3 2.3-1.9-.4-2.9-4.2-4.7-4.8-1.9-.7-4.9 1.7-6.7.8-1.8-.9-1.9-4.7-3.5-5.7-1.7-1-5.2.5-6.7-.7s-.8-5-2.2-6.4c-1.4-1.4-5.2-.6-6.4-2.2-1.2-1.5.3-5-.7-6.7-1-1.7-4.9-1.8-5.7-3.5-.8-1.8 1.5-4.8.8-6.7-.6-1.8-4.4-2.8-4.8-4.7-.4-1.9 2.5-4.4 2.3-6.3C20.4 74.8 17 73 17 71"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003803517852578498020000003361434978994900885_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109721811829382026760000014822334531668352164_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003803517852578498020000003361434978994900885_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000134219931227349016710000011861537533660776598_",
    d: "M-206-364h390v997h-390z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066509427830286660810000010193195540520578961_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134219931227349016710000011861537533660776598_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000066509427830286660810000010193195540520578961_)",
      fill: "#4cc2f1"
    },
    d: "M16 16h110v110H16z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147908545174178003400000009347634059567606937_",
    d: "M68.2 87.3c-1 0-1.7-.3-2.4-1-.6-.6-1-1.4-1-2.4s.3-1.7 1-2.4c.6-.6 1.4-1 2.4-1 .9 0 1.7.3 2.3 1 .6.6 1 1.4 1 2.4s-.3 1.7-1 2.4c-.6.7-1.3 1-2.3 1zm3-32.7c3.1 0 5.6.9 7.5 2.6 1.9 1.7 2.8 4.1 2.8 7 0 3.1-1 5.4-2.9 7-2 1.6-4.6 2.3-7.8 2.3l-.2 3.6H66l-.2-7.2h1.5c3 0 5.3-.4 6.8-1.2s2.4-2.3 2.4-4.6c0-1.6-.5-2.9-1.4-3.8-.9-.9-2.2-1.4-3.9-1.4s-3 .4-3.9 1.3c-1 .9-1.4 2.1-1.4 3.7H61c0-1.8.4-3.5 1.2-4.9s2-2.6 3.6-3.4c1.5-.6 3.3-1 5.4-1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034086517425678757170000012323439032755896476_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147908545174178003400000009347634059567606937_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034086517425678757170000012323439032755896476_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078029498509977050220000000258357020635727759_",
    d: "M-206-364h390v997h-390z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083065586599589737850000016882531024611554210_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078029498509977050220000000258357020635727759_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083065586599589737850000016882531024611554210_)",
      fill: "#31348b"
    },
    d: "M60 53.6h22.6v34.8H60z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.b60f4b22915aa456f5b378aa837262d1.svg";
export { ForwardRef as ReactComponent };